import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LeadModal from '../components/quiz/LeadModal';

const Wrap = styled.main`
  width: min(820px, 92vw);
  margin: 0 auto;
  padding: 22px 0 28px;
  display: grid;
  gap: 14px;
`;

/** Оранжевая плашка на странице */
const Notice = styled.div`
  margin-top: -2px;
  padding: 10px 12px;
  border-radius: 12px;
  color: var(--primary, #C7903E);
  border: 1px solid currentColor;
  background: rgba(199, 144, 62, .10);
  font-size: 0.95rem;
`;

export default function Quiz() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <Wrap>
      <h1 style={{ margin: '0 0 12px' }}>{t('quiz.title')}</h1>
      <p style={{ opacity: 0.8 }}>{t('quiz.lead')}</p>

      {/* Оранжевая надпись */}
      <Notice>{t('quiz.notice')}</Notice>

      {!open && (
        <button type="button" className="btn btn-primary" onClick={() => setOpen(true)}>
          {t('quiz.openCta')}
        </button>
      )}

      <LeadModal open={open} onClose={handleClose} />
    </Wrap>
  );
}
